import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import { useIsMobile } from "@hotelise/ui";

import {
	getPropertyReservationsList,
	getPropertyReservationsLoading,
} from "state/modules/properties";

import { Property } from "models/properties";
import { ReportTableItemWithTransfer } from "interfaces/reports";
import ReservationDetailsPanel from "./ReservationDetailsPanel";
import ReservationsList from "./ReservationsList";

interface Props {
	propertyDetails: Property;
}

const PropertyReservationsList = (props: Props): JSX.Element => {
	const [selectedReservation, setSelectedReservation] =
		useState<ReportTableItemWithTransfer | null>(null);

	const isMobile = useIsMobile();

	const propertyReservations = useSelector(getPropertyReservationsList);
	const isPropertyReservationsLoading = useSelector(
		getPropertyReservationsLoading
	);


	const handleSelectReservation = (
		reservation: ReportTableItemWithTransfer | null
	) => {
		setSelectedReservation(reservation);
	};

	return (
		<div>
			<ReservationsList
				reservations={propertyReservations}
				isLoading={isPropertyReservationsLoading}
				onSelect={handleSelectReservation}
				isMobile={isMobile}
			/>
			<ReservationDetailsPanel
				reservation={selectedReservation}
				open={!!selectedReservation}
				onOpenChange={(open) => {
					if (!open) setSelectedReservation(null);
				}}
			/>
		</div>
	);
};

export default PropertyReservationsList;
